import { FC, useEffect, useState } from "react";
import "./reset.css";
import useAuth from "../../../hooks/useAuth";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../../../services/api";
import { Loading } from "../../../components/Loading";
import { useAppConfig } from "../../../hooks/useAppConfig"; // <-- Adicionado

const ResetSenha: FC = () => {
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");

  const [loading, setLoading] = useState(false);
  const { loginInfo } = useAuth();
  const { getToken } = usePluginspace();
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();

  // Estados para a Cor Primária
  const { getAppConfig } = useAppConfig();
  const [primaryColor, setPrimaryColor] = useState("#078BD8");

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const conf = await getAppConfig();
        if (conf?.webappcolor?.webappbutton) {
          setPrimaryColor(conf.webappcolor.webappbutton);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchConfig();
  }, []);

  const atualizar = async () => {
    if (password !== passwordAgain) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "As senhas digitadas não são iguais.",
        confirmButtonColor: primaryColor,
      });
      setPassword("");
      setPasswordAgain("");
      return;
    }

    setLoading(true);

    await api
      .put(
        `/api/customer/${loginInfo.id}`,
        {
          password: password,
          addresses: [],
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then((response) => {
        setLoading(false);
        const changePassword = response.data;
        if (changePassword.success) {
          Swal.fire({
            icon: "success",
            title: "Sucesso!",
            text: "Senha atualizada com sucesso.",
            confirmButtonColor: primaryColor,
          }).then(() => navigate(`/${pluginspace_id}/profile`));
        } else {
          Swal.fire({
            icon: "error",
            title: "Erro ao atualizar senha!",
            text: "Não foi possível atualizar a senha.",
            confirmButtonColor: primaryColor,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Erro ao atualizar senha!",
          text: "Não foi possível atualizar a senha.",
          confirmButtonColor: primaryColor,
        });
      });
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            width: "100%",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "#FFF",
            zIndex: 10,
          }}
        >
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        <div className="perfil-reset-content">
          <div className="perfil-reset-header">
            <h2>Atualizar senha</h2>
          </div>

          <div className="perfil-reset-inputs-container">
            {/* Nova Senha */}
            <div className="perfil-reset-input-group">
              <label>Nova senha</label>
              <input
                className="perfil-reset-input"
                type="password"
                placeholder="******"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>

            {/* Repetir Nova Senha */}
            <div className="perfil-reset-input-group">
              <label>Repita a nova senha</label>
              <input
                className="perfil-reset-input"
                type="password"
                placeholder="******"
                value={passwordAgain}
                onChange={(event) => setPasswordAgain(event.target.value)}
              />
            </div>

            <button
              className="perfil-reset-btn"
              style={{ background: primaryColor }}
              onClick={() => atualizar()}
            >
              Atualizar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export { ResetSenha };
